module.exports = __webpack_public_path__ + "static/media/rpg_coliseu.a52e96b0.webp";